import { Button } from "@mui/material";

export default function ButtonConsultLogs({ children, ...props }) {
  return(
    // <Button sx={{textTransform: "initial", variant="outlined",fontSize:"0.7rem", textDecoration: "underline"}} {...props} color="blueSys">Gerenciar permissões</Button>
    <Button variant="outlined"    color="blueSys" sx={{textTransform: "initial"}} {...props}>Consultar Logs</Button>
)
}